import { render, staticRenderFns } from "./product-picker.vue?vue&type=template&id=c8f2f266&scoped=true&"
import script from "./product-picker.vue?vue&type=script&lang=js&"
export * from "./product-picker.vue?vue&type=script&lang=js&"
import style0 from "./product-picker.vue?vue&type=style&index=0&id=c8f2f266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f2f266",
  null
  
)

export default component.exports